import { PropType, computed, defineComponent } from 'vue'
import { Store } from 'pinia'
import { MapViewMode } from '@/pages/chargermap/contract/map'
import CityBoundaryRender from './cityBoundaryRender'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { ChargeMapContext } from '../chargerMap/index.model'

export default defineComponent({
  name: 'city-boundary-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)

    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig

    const renderComponent = computed(() => {
      return (
        props.componentStore?.viewMode !== MapViewMode.CountyLayout &&
        componentsConfig?.data_cards?.show
      )
    })

    return () => (
      <>
        {renderComponent.value ? (
          <>
            <CityBoundaryRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
            ></CityBoundaryRender>
          </>
        ) : null}
      </>
    )
  },
})
